import {
  DomainName,
  IDictMultilineTextInputControl,
  StringDomain,
  TControlName,
} from '@infotech-soe/metaschema';

import { TActionArgsValues } from '../../../../infrastructure/providers/abstract/IApiProvider';
import {
  DictMultilineFormControlViewModel,
  FormControlViewModelType,
  LocalizedProps,
} from '../../view-model/FormControlViewModel';
import { FormSource, FormSourceType } from '../../view-model/FormSource';

import {
  buildCommonDictionaryButtonModel,
  controlDomain,
  getValueFromArgsOrConfig,
} from './helpers';

const buildDictMultilineControl = async (
  item: IDictMultilineTextInputControl,
  localizedProps: LocalizedProps,
  args: TActionArgsValues,
  source: FormSource,
  domains: Array<{ name: TControlName; domain: DomainName }>
): Promise<DictMultilineFormControlViewModel> => {
  const domain = (await controlDomain(item, source, domains)) as StringDomain;
  return {
    ...buildCommonDictionaryButtonModel(item, source),
    canClearOnReadOnly: item.canClearOnReadOnly,
    outParams: item.outParams,

    columns: item.columns,
    hideDictionaryButton: item.hideDictionaryButton,
    disabled: item.disabled,
    enableButtonOnReadOnly: source.type !== FormSourceType.REVIEW,
    hasHistory: false,
    hasValue: true,
    labelWidth: item.labelWidth,
    lengthInBytes: domain.lengthInBytes,
    maxLength: domain.length,
    name: item.name,
    noLabel: item.noLabel,
    readonly: item.readonly,
    required: item.required,
    rows: item.rows || 3,
    storeValue: item.storeValue,
    trim: item.trim,
    type: FormControlViewModelType.DICT_MULTILINE,
    value: getValueFromArgsOrConfig(item, args, source, ''),
    visible: item.visible,
    ...localizedProps,
  };
};

export default buildDictMultilineControl;
